import React, { useState } from "react";
import "./AdminBenefits.css";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const employeesData = [
  { id: 1, name: "John Doe", email: "john.doe@example.com", position: "Software Engineer", image: "https://i.pravatar.cc/40?img=1" },
  { id: 2, name: "Jane Smith", email: "jane.smith@example.com", position: "Project Manager", image: "https://i.pravatar.cc/40?img=2" },
  { id: 3, name: "Mark Johnson", email: "mark.johnson@example.com", position: "UI/UX Designer", image: "https://i.pravatar.cc/40?img=3" },
  { id: 4, name: "Emily Davis", email: "emily.davis@example.com", position: "HR Specialist", image: "https://i.pravatar.cc/40?img=4" },
  { id: 5, name: "Michael Brown", email: "michael.brown@example.com", position: "QA Tester", image: "https://i.pravatar.cc/40?img=5" },
  { id: 6, name: "Sarah Wilson", email: "sarah.wilson@example.com", position: "Frontend Developer", image: "https://i.pravatar.cc/40?img=6" },
  { id: 7, name: "David Lee", email: "david.lee@example.com", position: "Backend Developer", image: "https://i.pravatar.cc/40?img=7" },
  { id: 8, name: "Laura Martinez", email: "laura.martinez@example.com", position: "Product Owner", image: "https://i.pravatar.cc/40?img=8" },
  { id: 9, name: "James Anderson", email: "james.anderson@example.com", position: "Business Analyst", image: "https://i.pravatar.cc/40?img=9" },
  { id: 10, name: "Olivia Taylor", email: "olivia.taylor@example.com", position: "Tech Lead", image: "https://i.pravatar.cc/40?img=10" },
];

const defaultRates = {
  SSS: { employer: 900, employee: 300 },
  PhilHealth: { employer: 500, employee: 500 },
  PagIbig: { employer: 100, employee: 100 },
};

export default function AdminBenefits() {
  const [selectedBenefit, setSelectedBenefit] = useState("SSS");
  const [startDate, setStartDate] = useState(new Date(2025, 0, 1));
  const [endDate, setEndDate] = useState(new Date(2025, 0, 15));

  const [contributions, setContributions] = useState(() => {
    const init = {};
    Object.keys(defaultRates).forEach((benefit) => {
      init[benefit] = employeesData.map((emp) => ({
        ...emp,
        employer: defaultRates[benefit].employer,
        employee: defaultRates[benefit].employee,
        isEditing: false,
      }));
    });
    return init;
  });

  const handleEditToggle = (benefit, id) => {
    setContributions((prev) => ({
      ...prev,
      [benefit]: prev[benefit].map((emp) =>
        emp.id === id ? { ...emp, isEditing: !emp.isEditing } : emp
      ),
    }));
  };

  const handleChange = (benefit, id, field, value) => {
    setContributions((prev) => ({
      ...prev,
      [benefit]: prev[benefit].map((emp) =>
        emp.id === id ? { ...emp, [field]: value } : emp
      ),
    }));
  };

  const handleSave = (benefit, id) => {
    setContributions((prev) => ({
      ...prev,
      [benefit]: prev[benefit].map((emp) =>
        emp.id === id ? { ...emp, isEditing: false } : emp
      ),
    }));
  };

  const currentList = contributions[selectedBenefit];

  return (
    <div className="benefits-page">
      <Header />
      <SubHeader />
      <div className="benefits-container">
        <h2 className="benefits-header-row">
          <span className="benefits-header">
            BENEFITS &gt; {selectedBenefit}
          </span>

          <div className="filters">
            <div className="filter-item">
              <label className="filter-label">Date:</label>
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(dates) => {
                  const [start, end] = dates;
                  setStartDate(start);
                  setEndDate(end);
                }}
                dateFormat="MMMM d, yyyy"
                className="filter-input"
              />
            </div>

            <div className="filter-item">
              <label className="filter-label">Benefit Type:</label>
              <select
                value={selectedBenefit}
                onChange={(e) => setSelectedBenefit(e.target.value)}
                className="filter-select"
              >
                <option value="SSS">SSS</option>
                <option value="PhilHealth">PhilHealth</option>
                <option value="PagIbig">Pag-IBIG</option>
              </select>
            </div>
          </div>
        </h2>

        {/* Table */}
        <div className="table-wrapper">
          <table className="contribution-table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Email</th>
                <th>Position</th>
                <th>Employer Share</th>
                <th>Employee Share</th>
                <th>Total Contribution</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentList.map((emp) => (
                <tr key={emp.id}>
                  <td className="emp-cell">
                    <img src={emp.image} alt={emp.name} className="emp-img" />
                    <span>{emp.name}</span>
                  </td>
                  <td>{emp.email}</td>
                  <td>{emp.position}</td>

                  {/* Editable Employer Share */}
                  <td>
                    {emp.isEditing ? (
                      <input
                        type="number"
                        value={emp.employer}
                        onChange={(e) =>
                          handleChange(selectedBenefit, emp.id, "employer", parseFloat(e.target.value))
                        }
                        className="edit-input"
                      />
                    ) : (
                      `Php ${emp.employer.toFixed(2)}`
                    )}
                  </td>

                  {/* Editable Employee Share */}
                  <td>
                    {emp.isEditing ? (
                      <input
                        type="number"
                        value={emp.employee}
                        onChange={(e) =>
                          handleChange(selectedBenefit, emp.id, "employee", parseFloat(e.target.value))
                        }
                        className="edit-input"
                      />
                    ) : (
                      `Php ${emp.employee.toFixed(2)}`
                    )}
                  </td>

                  {/* Total */}
                  <td className="total">
                    Php {(emp.employer + emp.employee).toFixed(2)}
                  </td>

                  {/* Action Icons */}
                  <td className="action-cell">
                    {emp.isEditing ? (
                      <button
                        className="icon-btn save-icon"
                        onClick={() => handleSave(selectedBenefit, emp.id)}
                        title="Save"
                      >
                        <i className="fa-solid fa-check"></i>
                      </button>
                    ) : (
                      <button
                        className="icon-btn edit-icon"
                        onClick={() => handleEditToggle(selectedBenefit, emp.id)}
                        title="Edit"
                      >
                        <i className="fa-solid fa-pen"></i>
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
